import React, { useState, useCallback, useEffect } from 'react';
import { Sidebar } from './components/Sidebar';
import { MainContent } from './components/MainContent';
import SimpleDialog from './components/SimpleDialog';
import { Menu } from 'lucide-react';
import useSentenceManager from './components/SentenceManager';
import './styles/App.css';

function App() {
  const [module, setModule] = useState('');
  const [subModule, setSubModule] = useState('');
  const [seconds, setSeconds] = useState(5);
  const [sentenceCount, setSentenceCount] = useState(10);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [exerciseState, setExerciseState] = useState('idle');
  const [isLoadingMenu, setIsLoadingMenu] = useState(false);
  const searchParams = new URLSearchParams(window.location.search);
  const id = searchParams.get('id') || 'visitor'; // Default to 'visitor' if 'id' is not present

  const { menuData, fetchSentences, sentences, error, resetError, markSentenceAsDisplayed } = useSentenceManager({
    module,
    subModule,
    sentenceCount,
    onMenuDataLoadStart: () => setIsLoadingMenu(true),
    onMenuDataLoadEnd: () => setIsLoadingMenu(false),
    id: id
  });

  const toggleSidebar = () => {
    if (exerciseState === 'idle' || exerciseState === 'finished') {
      setSidebarOpen(!sidebarOpen);
    }
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const handleExerciseStateChange = useCallback((newState) => {
    setExerciseState(newState);
    if (newState === 'running' || newState === 'paused') {
      setSidebarOpen(false);
    } else if (newState === 'idle' || newState === 'finished') {
      setSidebarOpen(true);
    }
  }, []);

  return (
    <div className="app">
      <SimpleDialog
        isOpen={isLoadingMenu}
        message="初期設定をしています"
      />
      <Sidebar 
        module={module}
        setModule={setModule}
        subModule={subModule}
        setSubModule={setSubModule}
        seconds={seconds} 
        setSeconds={setSeconds} 
        sentenceCount={sentenceCount}
        setSentenceCount={setSentenceCount}
        isOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
        disabled={exerciseState !== 'idle' && exerciseState !== 'finished'}
        menuData={menuData}
      />
      {!sidebarOpen && (exerciseState === 'idle' || exerciseState === 'finished') && (
        <button className="toggle-sidebar" onClick={toggleSidebar}>
          <Menu size={24} />
        </button>
      )}
      <MainContent 
        module={module}
        subModule={subModule}
        seconds={seconds}
        sentenceCount={sentenceCount}
        sidebarOpen={sidebarOpen}
        closeSidebar={closeSidebar}
        onExerciseStateChange={handleExerciseStateChange}
        fetchSentences={fetchSentences}
        sentences={sentences}
        error={error}
        resetError={resetError}
        markSentenceAsDisplayed={markSentenceAsDisplayed}
      />
    </div>
  );
}

export default App;